<button class="add-attachment" (click)="fileUploadInput.click()">
  <mat-icon svgIcon="attach" class="icon-24" />
  <input
    class="hidden"
    #fileUploadInput
    type="file"
    multiple
    (change)="uploadAttachments($event)"
  />
</button>
<div class="chat-text-input-wrapper">
  @if (attachments.length) {
    <div class="attachments">
      @for (attachment of attachments; track attachment.url; let index = $index) {
        @if (attachment.thumbnail) {
          <div class="attachment-image">
            <img [src]="attachment.thumbnail" alt="" />
            <button
              type="button"
              class="remove-attachment"
              blazeTooltip="Delete"
              (click)="deleteAttachment.emit(attachment)"
            >
              ✕
            </button>
          </div>
        } @else {
          <div class="attachment-file">
            <img [src]="attachmentsImages[attachment.filename]" alt="" />
            <span>{{ attachment.filename }}</span>
            <button
              type="button"
              class="remove-attachment"
              blazeTooltip="Delete"
              (click)="deleteAttachment.emit(attachment)"
            >
              ✕
            </button>
          </div>
        }
      }
    </div>
  }
  <div
    #textInput
    class="chat-text-input"
    contenteditable
    data-cy="ChatWidgetTextInput:textInput"
    [formControl]="formControl"
    [attr.aria-disabled]="inputDisabled"
    [attr.aria-placeholder]="placeholder"
    [attr.aria-label]="placeholder"
    role="textbox"
    spellcheck="false"
    tabindex="0"
    (paste)="paste($event)"
    (mousedown)="markEventAsHandled($event)"
    (keydown)="inputDisabled ? $event.preventDefault() : null"
    (keydown.enter)="onEnterPress($event)"
    (keydown.escape)="onEscapePress()"
  ></div>
  @if (isTextInputEmpty()) {
    @if (isViewAsMode) {
      <div aria-hidden="true" class="placeholder view-as-label">
        Viewing as: <span>{{ viewAsLabel }}</span>
      </div>
    } @else {
      <div aria-hidden="true" class="placeholder">
        {{ placeholder }}
      </div>
    }
  }
</div>
<div class="button-wrapper">
  <button
    type="button"
    class="send-msg-button"
    data-cy="ChatWidgetTextInput:submitMessageButton"
    [disabled]="isTextInputEmpty() && attachments.length === 0"
    blazeTooltip="Press Enter to send a message"
    [matTooltipDisabled]="isTextInputEmpty() && attachments.length === 0"
    (click)="submitMessage()"
  >
    <mat-icon [svgIcon]="isEditMode() ? 'icon_check_24' : 'arrow_up'" />
  </button>
</div>
